import Vue from 'vue'

/**
 * This mixin is just for props that are used for field-group fields.  This helps them
 * be consistent with the props of it's parents (text-field selectbox, etc)
 */
export default Vue.extend({
  props: {
    asFieldset: { type: Boolean, default: false },
    errorText: String,
    hintText: String,
    label: String,
    labelId: String,
    id: String,
    describedbyId: String, // aria-describedby for field, id for hint text
    required: { type: Boolean, default: false }
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/form/field-group-props-mixin.ts